import React, {useMemo, useCallback} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { getCurrentScreenType } from 'Helper/screenTypeHelpers'
import { updateDesignMode } from 'actions/uiDesignActions';
import { setScreen } from 'actions/interactableActions';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom'
import { push } from 'Helper/routeHelpers'

const DesignModeSubmenu = () => {
    const dispatch = useDispatch();
    const designMode = useSelector(state => state.interactableState.uiDesignMode);
    const currentScreenType = useMemo(getCurrentScreenType, [])
    const { pathname } = useLocation()
  
    const handleUpdateDesignMode = useCallback((newValue) => {
      if(newValue != currentScreenType) {
        // we are changing screen type so if we are on a workflow or screen it likely isn't compatible with the
        // new screen type so we will navigate to the base of whatever context we are in without a screen or workflow
        // selected
        const screenSplit = pathname.split('/screen')
        const workflowSplit = screenSplit[0].split('workflow')
        push(workflowSplit[0])
        // and clear the open windows since they may not be compatible
        dispatch(setScreen([]))
      }
      dispatch(updateDesignMode(newValue));
    }, [currentScreenType, updateDesignMode, setScreen, pathname])

    const designModeList = [
        {
            name: 'Standard screen',
            clickHandler: () => {handleUpdateDesignMode('standard')}
        },
        {
            name: 'iPad screen',
            clickHandler: () => {handleUpdateDesignMode('ipad')}
        },
    ]

    if (designMode) {
        designModeList.push(
            {
                name: '<Exit>',
                clickHandler: () => {handleUpdateDesignMode(null)}
            },
        )
    }

    return (
      <li
        className={'dropdown-submenu'}
      >
        <a
          className="dropdown-toggle"
          id="designModeDropDown"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="true"
          role="button"
          aria-labelledby="design mode"
        >
          <FontAwesomeIcon icon={['fas', 'compass-drafting']} />
          Design Mode
        </a>
        {
          <ul
            className="dropdown-menu dropdown-menu-right"
            aria-labelledby="design mode menu"
          >
            {designModeList.map((item, idx) => {
              return (
                <li key={item.name}>
                    <a
                        role="button"
                        aria-label={`${item.name} link`}
                        onClick={item.clickHandler}
                    >
                        {item.name}
                    </a>
                </li>
              )
            })}
          </ul>
        }
      </li>
    )
}

DesignModeSubmenu.propTypes = {
}

export default DesignModeSubmenu
